import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import scroll from 'quasar/src/utils/scroll.js';;
var getScrollTarget = scroll.getScrollTarget,
    setScrollPosition = scroll.setScrollPosition;
import { colorLuminance } from "../../../utils/utils";
import { calculateRating, getEmojiOptions, getExistingRatingByOption } from "../menuInsightHelpers/ratings";
import { shouldShowSubquestion } from "../menuInsightHelpers/rendering";
import { canLoadMoreItems } from "../../../functions/utils";
export default {
  name: 'MenuInsightsMajorGroupOffline',
  props: {
    allProductsAsInlineDishes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    products: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    question: {
      type: Object,
      required: true
    },
    response: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      modal: false,
      modalWarning: false,
      selectedDish: {},
      showSelectedDish: false,
      shownProducts: [],
      pageSize: 25,
      shouldShowSubquestion: shouldShowSubquestion
    };
  },
  computed: {
    bgImage: function bgImage() {
      return {
        backgroundImage: "url(".concat(this.$store.getters['theme/bgImage'], ")")
      };
    },
    emojiOptions: function emojiOptions() {
      return getEmojiOptions(this.question);
    },
    getModalDishes: function getModalDishes() {
      return this.allProductsAsInlineDishes;
    },
    overlay: function overlay() {
      return {
        color: colorLuminance(this.$store.getters['theme/theme'].primaryColor, -0.5)
      };
    }
  },
  mounted: function mounted() {
    this.shownProducts = this.products.slice(0, this.pageSize);
  },
  methods: {
    onScroll: function onScroll(val) {
      // check to see if more items could be added to the shown items in the array
      var shouldLoadMore = canLoadMoreItems(val, this.shownProducts, this.products, this.$refs.dishSelectionScrollContainer);

      if (shouldLoadMore) {
        var currentLastIndex = this.shownProducts.length;
        var newItems = this.products.slice(currentLastIndex, currentLastIndex + this.pageSize);
        this.shownProducts = [].concat(_toConsumableArray(this.shownProducts), _toConsumableArray(newItems));
      }
    },
    scrollToElement: function scrollToElement(id) {
      var el = document.getElementById(id);
      var target = getScrollTarget(el);
      var offset = el.offsetTop;
      var duration = 300;
      setScrollPosition(target, offset - 200, duration);
    },
    closeWithoutSave: function closeWithoutSave() {
      var _this = this;

      var dish = this.allProductsAsInlineDishes.find(function (i) {
        return i.ref === _this.selectedDish.ref || i.id == _this.selectedDish.ref;
      });
      this.closeModal(dish, false);
      this.modalWarning = false;
    },
    handleEmojiClicked: function handleEmojiClicked(value, item) {
      // For some reason this doesn't end up getting called in circumstances where it is newly selected, which is strange, but I won't rely on this to implement a solution here as it shouldn't be the case.  I won't bother fixing this now as no functionality currently requires this call to be made in those cases, but it is worth keeping note of.
      // if no item or value provided, ditch out
      if (!value || !item) {
        return;
      } // if follow up questions allowed, ditch out, (although in the future this functionality might be desied)


      if (this.question.followUpQuestion) {
        return;
      } // double check that there is an existing rating for item, and that the aspectRatingId matches the value provided


      var rating = getExistingRatingByOption(item, this.response); // if no rating or no match, ditch out

      if (!rating || rating.aspectRatingId !== value) {
        return;
      } // clear out rating


      this.clearDish(item);
    },
    handleResponse: function handleResponse(value, context) {
      var calculatedRating = calculateRating(value, context, this.responses);

      if (context.source === 'selectedDishEmoji' || !calculatedRating) {
        return; // not currently supporting inline selection in the 'selected dishes' area
      }

      var question = this.question;
      this.$store.dispatch('answers/upsertMenuInsightResponse', {
        question: question,
        rating: calculatedRating
      });
    },
    openModal: function openModal(dish) {
      var _dish$subQuestion;

      // if no dish provided, ditch out
      if (!dish) {
        return;
      } // if no follow up questions allowed, ditch out


      if (!this.question.followUpQuestion) {
        return;
      }

      this.selectedDish = dish;

      if (((dish === null || dish === void 0 ? void 0 : (_dish$subQuestion = dish.subQuestion) === null || _dish$subQuestion === void 0 ? void 0 : _dish$subQuestion.subQuestions) || []).length > 0) {
        this.showSelectedDish = true;
      }
    },
    closeModal: function closeModal(dish, check) {
      var dirty = this.isDirty(dish);

      if (check && dirty) {
        this.modalWarning = true;
        return;
      }

      this.selectedDish = null;
      this.showSelectedDish = false;
    },
    isDirty: function isDirty(dish) {
      var _this2 = this;

      var subQuestions = dish.subQuestions;
      var dirty = false;

      if (subQuestions) {
        subQuestions.forEach(function (subQuestion) {
          if (_this2.response[subQuestion.id]) {
            dirty = true;
          }
        });
      }

      return dirty;
    },
    getComments: function getComments(dish) {
      if (!dish || !dish.subQuestions || !dish.subQuestions.length) {
        return false;
      }

      var rating = this.response.find(function (r) {
        return r.ref === dish.ref;
      });
      var hasComments = rating ? dish.subQuestions.some(function (subQuestion) {
        return subQuestion && subQuestion.type === 'fib-comments' && rating.comment;
      }) : false;
      return hasComments;
    },
    getFibEmojiValue: function getFibEmojiValue(option) {
      var rating = this.response.find(function (r) {
        return r.ref === option.ref;
      });
      return rating ? rating.aspectRatingId : null;
    },
    getSubQuestionValue: function getSubQuestionValue(subQuestion, option) {
      var rating = this.response.find(function (r) {
        return r.ref === option.ref;
      });

      if (!rating) {
        return null;
      }

      var val = null;

      switch (subQuestion.type) {
        case 'fib-comments':
          val = rating.comment;
          break;

        case 'fib-select-option':
          val = rating.tags;
          break;
      }

      return val;
    },
    clearDish: function clearDish(dish) {
      // if no dish, ditch out
      if (!dish) {
        return;
      } // if no dish ref, or dish id, ditch out


      var id = dish.ref || dish.id;

      if (!id) {
        return;
      }

      this.selectedDish = null;
      this.showSelectedDish = false;
      this.$store.dispatch('answers/clearMenuInsightResponse', {
        question: this.question,
        id: id
      });
    },
    modalSaveButtonDisabled: function modalSaveButtonDisabled(dish) {
      return !this.response.some(function (r) {
        return r.ref === dish.ref;
      });
    }
  }
};